import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/cost-of-goods')({
  staticData: toStaticData(CRT_ROUTES['/crt/cost-of-goods']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
